export interface RuntimeEnvConfig {
  server?: {
    proxy?: {
      [route: string]: {
        target: string;
        changeOrigin?: boolean;
        secure?: boolean;
      };
    };
    allowedHosts?: string[];
  };
  okta?: {
    issuer?: string;
    clientId?: string;
    redirectUri?: string;
  };
  msClarity?: {
    id?: string;
    env?: string;
  };
}

let _config: RuntimeEnvConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeEnvConfig> {
  if (_config) return _config;
  try {
    const res = await fetch('/env.json', { cache: 'no-store' });
    if (!res.ok) {
      _config = {};
      return _config;
    }
    _config = (await res.json()) as RuntimeEnvConfig;
  } catch {
    _config = {};
  }
  return _config;
}

export function getApiBaseUrl(): string {
  const target = _config?.server?.proxy?.['/api']?.target?.trim();
  if (!target) return '';
  return target.replace(/\/?$/, '');
}

export function buildApiUrl(path: string): string {
  const base = getApiBaseUrl();
  if (!path.startsWith('/')) path = `/${path}`;
  if (base) {
    // avoid duplicate /api when base already has it
    if (base.endsWith('/api') && path.startsWith('/api')) {
      return `${base}${path.substring(4)}`;
    }
    return `${base}${path}`;
  }
  return path; // dev relative
}

export function getOktaIssuer(): string | undefined {
  return _config?.okta?.issuer?.trim();
}

export function getOktaClientId(): string | undefined {
  return _config?.okta?.clientId?.trim();
}

export function getOktaRedirectUri(): string | undefined {
  return _config?.okta?.redirectUri?.trim();
}

export function getMsClarityId(): string | undefined {
  return _config?.msClarity?.id?.trim();
}
export function getMsClarityEnv(): string | undefined {
  return _config?.msClarity?.env?.trim();
}
